import { PropsWithChildren, useState } from 'react'
import { useModal } from '@iveco-ti/iveco-ds'

import {
  ModalApplicationActions,
  ModalApplicationContext,
} from '../hooks/useModalApplication'

const INITIAL_MODAL_STATE: ModalApplicationActions = {
  title: '',
  description: undefined,
  cancelText: undefined,
  confirmText: undefined,
  onCancel: undefined,
  onConfirm: undefined,
  isLoading: false,
  showButtons: true,
}

export const ModalApplicationProvider = (props: PropsWithChildren) => {
  const [modalState, setModalState] =
    useState<ModalApplicationActions>(INITIAL_MODAL_STATE)
  const { open, close } = useModal('app-modal')

  const handleModal = (props: Omit<ModalApplicationActions, 'handleModal'>) => {
    setModalState((prev) => ({ ...prev, ...props }))
    open()

    setTimeout(() => {
      const clickEvent = new MouseEvent('click', {
        bubbles: true,
        cancelable: true,
      })
      document.body.dispatchEvent(clickEvent)
    }, 300)
  }

  const updateModal = (
    props: Partial<Omit<ModalApplicationActions, 'handleModal'>>,
  ) => {
    setModalState((prev) => ({ ...prev, ...props }))
  }

  const toggleLoading = () => {
    setModalState((prev) => ({ ...prev, isLoading: !prev.isLoading }))
  }

  const resetModal = () => {
    setModalState(INITIAL_MODAL_STATE)
    close()
  }

  return (
    <ModalApplicationContext.Provider
      value={{
        ...modalState,
        handleModal,
        updateModal,
        toggleLoading,
        resetModal,
      }}
    >
      {props.children}
    </ModalApplicationContext.Provider>
  )
}
